import { useContext, useEffect } from 'react';
import { GlobalStoreCtx } from '@/stores/GlobalStore';

export const useDateChanged = ({ prevCheckinDate, prevCheckoutDate, checkinDate, checkoutDate, text }): void => {
  const globalStore = useContext(GlobalStoreCtx);

  useEffect(() => {
    if (prevCheckinDate === undefined || prevCheckoutDate === undefined) {
      return
    }
    if (prevCheckinDate !== checkinDate || prevCheckoutDate !== checkoutDate) {
      globalStore.toast.addItem({
        key: 'date-changed',
        text,
        timeout: 2000,
      });
    }
  }, [checkinDate, checkoutDate]);
};
